import { useCallback as e } from "react";
import { useTranslation as t } from "react-i18next";
import { HousekeepingRefusal as n } from "@maat/api-main/types";
//#region src/enums/useTrHousekeepingRefusal.ts
var r = new Set(Object.values(n)), i = (e) => typeof e == "string" ? e : e?.response?.data?.code, a = () => {
	let { t: n } = t("frontDesk");
	return e((e) => {
		let t = i(e);
		return typeof t == "string" && r.has(t) ? n(`rooms.board.refusal.${t}`) : void 0;
	}, [n]);
};
//#endregion
export { a as useTrHousekeepingRefusal };
